import InnerScreen from '../../components/Inner Screens/InnerScreen';
import { Link } from 'react-router-dom'; 
import MasterComonent from '../../components/Backend/MasterComonent';

const IntegrationScreens = () => {
    return (
        <div className='modules_screen_lynkaz'>
            <MasterComonent> 
                <InnerScreen innerTitle='Integration Manager'>
                    <div className='col-lg-3 col-md-4 col-xs-6 gy-4'>
                        <div className='inner-page-header border-bottom'> 
                            <h2>Api Manager</h2>
                            {/* <h2>App</h2> */}
                        </div>
                        <div className='inner-page-routes'>
                            <Link to='/api-manager-forms'>Api Manager</Link>
                            {/* <Link to='/app-forms'>App</Link>  */}
                        </div>
                    </div>

                    <div className='col-lg-3 col-md-4 col-xs-6 gy-4'> 
                        <div className='inner-page-header border-bottom'>
                            <h2>Tenants</h2>
                        </div>
                        <div className='inner-page-routes'>
                            <Link to='/tenant-forms'>Tenants</Link> 
                        </div>
                    </div>

                    {/* <div className='col-lg-3 col-md-4 col-xs-6 gy-4'> 
                        <div className='inner-page-header border-bottom'>
                            <h2>Api Master</h2>
                        </div>
                        <div className='inner-page-routes'>
                            <Link to='/api-master-forms'>Api Master</Link> 
                        </div>
                    </div> */}

                    <div className='col-lg-3 col-md-4 col-xs-6 gy-4'> 
                        <div className='inner-page-header border-bottom'>
                            <h2>App Master</h2>
                        </div>
                        <div className='inner-page-routes'>
                            <Link to='/app-master-forms'>App Master</Link> 
                        </div>
                    </div>

                    {/* <div className='col-lg-3 col-md-4 col-xs-6 gy-4'> 
                        <div className='inner-page-header border-bottom'>
                            <h2>Operation Mapping</h2>
                        </div>
                        <div className='inner-page-routes'>
                            <Link to='/operation-mapping-forms'>Operation Mapping</Link> 
                        </div>
                    </div> */}

                    {/* <div className='col-lg-3 col-md-4 col-xs-6 gy-4'> 
                        <div className='inner-page-header border-bottom'>
                            <h2>External System API</h2>
                        </div>
                        <div className='inner-page-routes'>
                            <Link to='/external-system-api-forms'>External System API</Link> 
                        </div>
                    </div> */}

                    <div className='col-lg-3 col-md-4 col-xs-6 gy-4'> 
                        <div className='inner-page-header border-bottom'>
                            <h2>Lynkaz API Details</h2>
                        </div>
                        <div className='inner-page-routes'>
                            <Link to='/lynkaz-api-details-forms'>Lynkaz API Details</Link> 
                        </div>
                    </div>

                    {/* <div className='col-lg-3 col-md-4 col-xs-6 gy-4'> 
                        <div className='inner-page-header border-bottom'>
                            <h2>Credentials Store</h2>
                        </div>
                        <div className='inner-page-routes'>
                            <Link to='/credentials-store-forms'>Credentials Store</Link> 
                        </div>
                    </div> */}

                    <div className='col-lg-3 col-md-4 col-xs-6 gy-4'> 
                        <div className='inner-page-header border-bottom'>
                            <h2>Integration Monitor</h2>
                        </div>
                        <div className='inner-page-routes'>
                            <Link to='/integration-monitor-forms'>System Integration Monitor</Link> 
                        </div>
                    </div>
                </InnerScreen> 
            </MasterComonent>    
        </div>
    )
};

export default (IntegrationScreens);